import React, { useContext } from 'react';
import MultiSelectionAddon from './multi-selection-addon';
import MultiSelectionWithQuantityAddon from './multi-selection-quantity-addon';
import SingleSelectionAddon from './single-selection-addon';
import { AddonCategoryType, ENUM_ADDON_SELECTION } from 'models/addon-category.model';
import { AddonType } from 'models/addon.model';
import { CreateOrderContext } from '../../contexts/create-order-context';
import { doesAddonExist, handleAddAddon, handleSubtractAddon } from '../../functions';

const AddOns = () => {
  const { addonCategory, active, addonSelection, setAddonSelection } =
    useContext(CreateOrderContext);
  const filteredAddOn = addonCategory.filter(({ name }) => active === name);
  const handleSelectAddon = (addon: AddonType, item: AddonCategoryType) => {
    const addonId: string = item?.id;
    const type: ENUM_ADDON_SELECTION = item?.meal_category_selection_type?.name;
    if (type === 'SINGLE_SELECTION') {
      addonSelection[addonId] = {
        name: addon.name ?? addon.meal_data.name,
        id: addon.meal_data?.id,
        quantity: 1,
        price: Number(addon.meal_data?.amount),
        is_addon: true
      };
    }
    if (type === 'MULTI_SELECTION') {
      const maxLength = Number(item?.selection_no) || 100;
      const arrLength = Object.keys(addonSelection).length;
      const addonId = addon.meal_data.id;
      if (doesAddonExist(addonId, addonSelection)) {
        delete addonSelection[addon.meal_addon_id];
      } else if (arrLength < maxLength) {
        addonSelection[addon.meal_addon_id] = {
          name: addon.name ?? addon.meal_data.name,
          id: addon.meal_data.id,
          quantity: 1,
          price: Number(addon.meal_data?.amount),
          is_addon: true
        };
      }
    }
    setAddonSelection({ ...addonSelection });
  };

  const handleQtyChange = (addon: AddonType, newQty: number, oldQty = 0) => {
    if (newQty > oldQty) {
      setAddonSelection(handleAddAddon(addon, addonSelection));
    } else {
      setAddonSelection(handleSubtractAddon(addon, addonSelection));
    }
  };

  return (
    <div>
      <SingleSelectionAddon
        filteredAddOn={filteredAddOn}
        handleSelectAddon={handleSelectAddon}
        addonSelection={addonSelection}
      />
      <MultiSelectionAddon
        filteredAddOn={filteredAddOn}
        addonSelection={addonSelection}
        handleSelectAddon={handleSelectAddon}
      />
      <MultiSelectionWithQuantityAddon
        filteredAddOn={filteredAddOn}
        handleSelectAddon={handleSelectAddon}
        onQtyChange={handleQtyChange}
        addonSelection={addonSelection}
      />
    </div>
  );
};

export default AddOns;
